import { connect } from 'react-redux';
import { createSubmitAction } from '../../app/forms';
import { FormattedMessage } from 'react-intl';
import { push } from 'react-router-redux';
import Alert from '../../../ui/Alert';
import LoginForm from '../forms/Login';
import Page from '../../app/components/Page';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styles from './css/Login.scss';

import {
    LOGIN_SUBMIT,
    LOGIN_SUCCESS,
    LOGIN_FAILURE,
} from '../../app/session';

export class Login extends Component {
    static propTypes = {
        children: PropTypes.node,
        dispatch: PropTypes.func.isRequired,
        redirectRoute: PropTypes.string,
    }

    constructor(...args) {
        super(...args);
        this.state = { erroneous: false, conflict: null };
    }

    componentWillMount() {
        if (this.props.session) {
            if (this.props.session.get('authenticated')) {
                this.redirect()
            }
        }
    }

    handleSubmitSuccess = () => {
        this.redirect()
    }

    redirect() {
        const { tenant } = this.props;
        if (tenant && tenant.get('code_part')) {
            this.props.dispatch(push('/order/region'));
        } else {
            this.props.dispatch(push('/select'));
        }
    }

    handleSubmitFailure = () => {
        const { form } = this.props;
        const conflict = form.getIn(['account', 'login', 'submitErrors', 'conflict']);
        if (conflict) {
            this.setState({conflict})
        }
        this.setState({ erroneous: true });
    }

    render() {
        const { erroneous, conflict } = this.state;

        return (
            <Page.Body>
                <div className={styles.wrapper}>
                    {erroneous && (
                        <Alert type='danger'>
                            {conflict ? conflict : <FormattedMessage id='frontend.form_login.message.invalid' />}
                        </Alert>
                    )}
                    <LoginForm.Component
                        onSubmitFail={this.handleSubmitFailure}
                        onSubmitSuccess={this.handleSubmitSuccess}
                        onSubmit={createSubmitAction(
                            LOGIN_SUBMIT,
                            LOGIN_SUCCESS,
                            LOGIN_FAILURE,
                        )}
                    />
                </div>
            </Page.Body>
        );
    }
}

export default connect((state) => ({
    form: state.form,
    session: state.session,
    tenant: state.tenant,
}))(Login);
